import moment from "moment";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";

import Link from "../components/Link";
import * as ArticleController from "../controllers/article-controller";
import { DATE_FORMAT_UTC } from "../utils/consts";
import { resolveNbsp } from "../utils/resolveNbsp";
import MainContainer from "./MainContainer";

interface IError404Props {
  title?: string;
}

const Error404 = ({ title }: IError404Props) => {
  const [articles, setArticles] = useState<Nullable<ArticleResponse[]>>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const getArticles = async () => {
      const response = await ArticleController.getArticlesByFilter({
        start: 0,
        total: 2,
        filter: {
          is_draft: false,
          end_date: moment(new Date()).format(DATE_FORMAT_UTC),
        },
      });
      setArticles(response?.list || null);
    };
    getArticles();
  }, []);

  return (
    <MainContainer
      ogTitle={t("JournalTitle")}
      ogUrl={"https://onlinepatent.ru/journal/"}
      ogImg={"https://onlinepatent.ru/content/img/bl_onpat.png"}
      ogDescription={title || t("NotFound")}
    >
      <div className="main-columns error-page">
        <div className="main-columns__center">
          <div className="wrap">
            <div className="error-page__holder">
              <div className="error-page__title-block">
                <p className="prime-title error-page__title">404</p>
                <p className="error-page__subtitle">{t("NotDoneYet")}</p>

                <Link
                  to="/"
                  className="btn btn-fond size-xl blue lighten-up scale-up"
                >
                  <span className="icon icon-arrow-btn btn__icon" />
                  <i className="btn__text">{t("GoToMain")}</i>
                </Link>
              </div>
              <div className="error-page__link-block">
                {articles && (
                  <div className="error-page__cards">
                    <p className="error-page__cards-title">
                      {t("WeHaveBetter")}:
                    </p>
                    {articles?.map((article) => (
                      <Link
                        to={article.article_index}
                        className="error-page__card"
                        key={article.article_id}
                      >
                        <p className="error-page__card-title">
                          {article.article_name}
                        </p>
                        <p className="error-page__card-text">
                          {resolveNbsp(article.seo_description)}
                        </p>
                        <p className="link link-blank size-xs">
                          <i className="link__text">{t("Link")}</i>
                          <span className="icon icon-arrow-blank link__icon" />
                        </p>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default Error404;
